// extracted by mini-css-extract-plugin
export default {"article":"SwapPage_article__pfrTf","header":"SwapPage_header__tDm71","title":"SwapPage_title__5K3Ca","action":"SwapPage_action__SJ5hE","description":"SwapPage_description__SPaTL"};